var React = require('react');
var ReactDOM = require('react-dom');
var css = require('./table.scss');
var TableFixedHead = require('./tableFixedHead.js');
const $ = require('jquery');

/**
 * <ScrollTable data={this.state.tableScroll}/>
 * struct: [
        {title: '姓名', key: 'name', width: 200, fixed: 'left'},
        {title: '手机号码', key: 'phone', width: 200, fixed: 'left'},
        {title: '备注', key: 'remark',  width: 200},
        {title: '更新时间', key: 'time', width: 200},
        {title: 'column1', key: 'column1', width: 200},
        {title: 'column2', key: 'column2', width: 200},
        {title: 'column3', key: 'column3', width: 200},
        {title: 'column4', key: 'column4', width: 200},
        {title: 'column5', key: 'column5', width: 200, fixed: 'right'}
    ]
 *
 * 注意： 每一列都需给宽度，如果没有给宽度，则会给默认宽度80，
 * 若每一列宽度和小于100%，则平均拉伸每一列的宽度至填满100%（针对非fixed）
 */
var cellMinWidth = 80;

var TableFixedCol = React.createClass({
    getInitialState: function() {
        var result = this.formatData(this.props.data);
        return {
            leftShadow: false,
            rightShadow: true,
            leftData: result.leftData,
            rightData: result.rightData,
            tableWidth: result.width,
            rowStyle: []
        };
    },

    componentWillReceiveProps: function(nextProps) {
        let result = this.formatData(nextProps.data);
        this.setState({
            leftData: result.leftData,
            rightData: result.rightData,
            tableWidth: result.width
        });

        // 非首次渲染的情况，也要重新计算主表格高度；shouldRender用来控制主表格渲染后同步更新左右表格
        if (this.elem && this.state.rowStyle.length > 0) {
            this.state.shouldRender = true;
            this.getRowStyle();
        }
    },

    componentDidUpdate: function() {
        // 主表格更新后，重新计算高度，并且通过setState重新渲染左右表格
        if (!this.elem || this.state.shouldRender) {
            this.state.shouldRender = false;
            this.getRowStyle();
        }
    },

    formatData: function(data) {
        var leftData = {
            struct: [],
            stripe: data.stripe,
            tableHead: data.titleLeftHead,
            data: data.data
        };
        var rightData = {
            struct: [],
            stripe: data.stripe,
            tableHead: data.titleRightHead,
            data: data.data
        };
        var width = 0;

        data.struct.map((item, index) => {
            width += (item.width || cellMinWidth);
            if (item.fixed == 'left') {
                leftData.struct.push(item);
            } else if (item.fixed == 'right') {
                rightData.struct.push(item);
            }
        });

        return {
            leftData,
            rightData,
            width
        };
    },

    // 处理左右table的阴影
    onScroll: function(e) {
        var scrollLeft = e.target.scrollLeft;
        var flagL = false, flagR = true;
        if (scrollLeft > 0) {
            flagL = true;
        } else {
            flagL = false;
        }

        if (scrollLeft >= (this.state.tableWidth - e.target.clientWidth - 2)) {
            flagR = false;
        } else {
            flagR = true;
        }
        this.setState({
            leftShadow: flagL,
            rightShadow: flagR
        });
    },

    // 计算content table每一行的高度，左右table每一行的高度保持跟content table行高一致
    getRowStyle: function() {
        if (!this.refs.contentTable) {
            return null;
        }
        this.elem = this.refs.contentTable.getDOMNode();
        let rowStyle = [];
        $(this.elem).find('tr').each((index, item) => {
            // rowStyle.push({ height: $(item).height() });
            // 高度兼容浏览器，浏览器是要小数点，$(item).height()只能获取到整数
            let _height = parseFloat(item.getBoundingClientRect().bottom - item.getBoundingClientRect().top).toFixed(2);
            rowStyle.push({ height: _height });
        });

        this.setState({
            rowStyle: rowStyle
        });
    },

    render: function() {
        var leftCls = ['fp-table-left-wrap'];
        var rightCls = ['fp-table-right-wrap'];
        if (this.state.leftShadow) {
            leftCls.push('left-shadow');
        }
        if (this.state.rightShadow) {
            rightCls.push('right-shadow');
        }
        let tableWrapWidth;

        let scrollContentStyle = {};
        if (this.props.initHeight) {
            scrollContentStyle.height = this.props.initHeight;
            scrollContentStyle.overflowY = 'auto';
        }

        return <div className = "fp-table-scroll-wrap">
            <div className="fp-table-scroll-content" onScroll={this.onScroll} ref={o => {
                tableWrapWidth = $(o).width();
            }} style={scrollContentStyle}>
                <TableFixedHead
                    ref="contentTable"
                    data={this.props.data}
                    style={{ width: tableWrapWidth }}
                    minWidth={cellMinWidth}/>
            </div>

            {
                this.state.leftData.struct.length > 0 ?
                    <div className={leftCls.join(' ')}>
                        <TableFixedHead data={this.state.leftData}
                            minWidth={cellMinWidth}
                            rowStyle={this.state.rowStyle}
                            isFixedLeft={true}/>  {/* 保持两边table的tr行高与content table行高一致 */}
                    </div>
                    : null
            }
            {
                this.state.rightData.struct.length > 0 ?
                    <div className={rightCls.join(' ')}>
                        <TableFixedHead data={this.state.rightData}
                            minWidth={cellMinWidth}
                            rowStyle={this.state.rowStyle}
                            isFixedRight={true}/>  {/* 保持两边table的tr行高与content table行高一致 */}
                    </div>
                    : null
            }
        </div>;
    }
});

module.exports = TableFixedCol;



// WEBPACK FOOTER //
// ./component/table/scrollTable.js